import importReact from "../../utils/importReact";

export default function initChatBot() {
  const entrypoint = document.getElementById("chatbot");
  if (entrypoint) {
    import(/* webpackChunkName: "chatBot" */ "./ChatBot").then((e) => {
      const { token, userId } = entrypoint.dataset;
      importReact().then(([React, ReactDOM]) => {
        ReactDOM.render(
          React.createElement(e.default, {
            token,
            userId
          }),
          entrypoint
        );
      });
    });
  }
}
